import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const LoadingPlaceholders = ({ columnCount = 3 }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  // Calculate appropriate number of placeholders based on column count
  const placeholderCount = columnCount * 2;
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
      {Array.from({ length: placeholderCount }).map((_, idx) => (
        <motion.div 
          key={idx} 
          className="card overflow-hidden h-[350px] neo-civic-grid"
          initial={mounted ? { opacity: 0, y: 15 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: idx * 0.05 }}
        >
          {/* Image placeholder */}
          <div className="h-44 relative bg-[var(--c-bg)]">
            {/* Pulse effect */}
            <motion.div 
              className="absolute inset-0 bg-[var(--c-border)]"
              initial={false}
              animate={mounted ? { opacity: [0.05, 0.1, 0.05] } : { opacity: 0.05 }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
            
            {/* Center icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                className="w-8 h-8 text-[var(--c-border)]"
                strokeWidth="1" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
            </div>
          </div>
          
          {/* Content section */}
          <div className="p-4 space-y-4">
            {/* Header placeholder */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[var(--c-accent)]"></div>
                <div className="h-4 w-32 bg-[var(--c-border)] rounded"></div>
              </div>
              <div className="h-4 w-16 bg-[var(--c-border)] rounded-full"></div>
            </div>
            
            {/* Status tag placeholders */}
            <div className="flex gap-2">
              <div className="h-5 w-24 bg-[var(--c-border)] rounded-full"></div>
              <div className="h-5 w-20 bg-[var(--c-border)] rounded-full"></div>
            </div>
            
            {/* Text content placeholders */}
            <div className="space-y-2">
              <div className="h-3 w-full bg-[var(--c-border)] rounded"></div>
              <div className="h-3 w-full bg-[var(--c-border)] rounded"></div>
              <div className="h-3 w-3/4 bg-[var(--c-border)] rounded"></div>
            </div>
            
            {/* Button placeholders */}
            <div className="flex justify-between items-center pt-2">
              <div className="h-3 w-24 bg-[var(--c-border)] rounded"></div>
              <div className="h-4 w-20 bg-[var(--c-border)] rounded"></div>
            </div>
          </div>
          

        </motion.div>
      ))}
    </div>
  );
};

export default LoadingPlaceholders; 